import { useRef, useEffect } from "react";
const useInitialization = ({
  onChange,
  getAddress,
  placeId,
  lat,
  lng,
  value
}) => {
  const refs = useRef({ onChange });
  refs.current = {
    onChange
  }, useEffect(() => {
    (async () => {
      var _a, _b;
      if (getAddress && placeId) {
        const address = await getAddress({ placeId });
        address && ((_b = (_a = refs.current).onChange) == null || _b.call(_a, address));
      }
    })();
  }, [getAddress, placeId]), useEffect(() => {
    (async () => {
      var _a, _b;
      if (getAddress && lat && lng) {
        const address = await getAddress({ location: { lat, lng } });
        address && ((_b = (_a = refs.current).onChange) == null || _b.call(_a, address));
      }
    })();
  }, [getAddress, lat, lng]), useEffect(() => {
    (async () => {
      var _a, _b;
      if (getAddress && value) {
        const address = await getAddress({ address: value });
        address && ((_b = (_a = refs.current).onChange) == null || _b.call(_a, address));
      }
    })();
  }, [getAddress, value]);
};
export {
  useInitialization
};
//# sourceMappingURL=useInitialization.js.map
